export { CorrelationGeneratorComponent } from './correlation-generator.component';
export { generateCorrelatedData, pearsonR, computeRSquared } from './correlation-distributions.util';
export type { CorrelatedPair } from './correlation-distributions.util';
export type { CorrelationGeneratorConfig, RelationshipType, CurveDirection } from './correlation-generator.model';
export type { CorrelationLibraryDataset } from './correlation-library-datasets.model';
export { CORRELATION_LIBRARY_DATASETS } from './correlation-library-datasets.model';
